export const healthCheckboxOptions = [
  { key: "Vegan", value: "vegan" },
  { key: "vegeterian", value: "vegeterian" },
  { key: "Alcohol Free", value: "alcohol-free" },
  { key: "Peanut Free", value: "peanut-free" },
  { key: "Sugar-conscious", value: "low-sugar" },
];
